import { apiFetch } from './client'

export interface LoginResult {
  token: string
  user: { id: string; name: string; email: string; role: string }
}

export function login(email: string, password: string) {
  return apiFetch<LoginResult>('/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  })
}
